/* globals Swiper */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import { sliderPagination } from '~/js/helpers';

const testimonialSliders = [...document.querySelectorAll('.testimonials-slider')];

testimonialSliders.forEach((testimonialSlidersSection) => {
	const testimonialSlider = testimonialSlidersSection.querySelector('.swiper-testimonials-slider');

	if (!testimonialSlider) return;

	const slidesPerView = Number(testimonialSlider.dataset.swiperColumns) || 3;

	const swiper = new Swiper(testimonialSlider, {
		modules: [Navigation, Pagination, A11y],
		a11y: true,
		grabCursor: true,
		loop: false,
		slidesPerView: 1,
		spaceBetween: 2,
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: testimonialSlider.querySelector('.swiper-button-next'),
			prevEl: testimonialSlider.querySelector('.swiper-button-prev'),
		},
		pagination: sliderPagination(testimonialSlider.querySelector('.swiper-pagination')),
		breakpoints: {
			760: { slidesPerView: slidesPerView },
			1024: { slidesPerView: slidesPerView },
		},
	});
});
